import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import {
  defaultIsEmptyText,
  EditorPlaceHolder,
  PlaceHolder,
} from '../../../../../shared/components/IELTSample/Outline/Paragraph/components/EditorPlaceHolder';
import { colorsV2 } from '../../../../colors-v2';
import { BaseQuotePluginProps, ELEMENT_QUOTE_CONTENT_CLASSNAME } from '../QuotePlugin.types';

const PLACE_HOLDER_WIDTH = 98;

const Main = styled.div`
  font-weight: 300;
  font-size: 20px;
  color: ${colorsV2.black100};

  .placeholder {
    left: 8px;
  }

  .text {
    > span {
      white-space: pre-wrap;
      word-break: break-word;
      display: inline;
    }

    &:before {
      content: '“';
    }

    &:after {
      content: '”';
    }
  }

  &.empty-text {
    .text > span {
      min-width: ${PLACE_HOLDER_WIDTH}px;
      display: inline-block;
    }
  }
`;

interface QuoteElementContentProps extends BaseQuotePluginProps {}

export const QuoteElementContentEditable = (props: QuoteElementContentProps) => {
  const { element, attributes, children, isReadOnly } = props;

  const isEmptyText = defaultIsEmptyText(element);

  return (
    <Main
      {...attributes}
      className={cl('font-noto', ELEMENT_QUOTE_CONTENT_CLASSNAME, { 'empty-text': isEmptyText })}
    >
      <EditorPlaceHolder
        isEmptyText={() => {
          return isEmptyText;
        }}
        isReadOnly={isReadOnly}
        placeHolderText="Text Quote"
      >
        {children}
      </EditorPlaceHolder>
    </Main>
  );
};

const TextContainer = styled.p`
  white-space: pre-wrap;
`;

export const QuoteElementContentReadOnly = (props: QuoteElementContentProps) => {
  const { element, attributes, children, isReadOnly } = props;

  const isEmptyText = defaultIsEmptyText(element);
  if (isEmptyText) {
    return (
      <PlaceHolder
        isEmptyText={() => {
          return isEmptyText;
        }}
        isReadOnly={isReadOnly}
        placeHolderText="Text Quote"
      >
        {children}
      </PlaceHolder>
    );
  }

  return <TextContainer {...attributes}>{children}</TextContainer>;
};
